import axios from 'axios';

export async function fulfillShopifyOrder(orderId, lineItemId, trackingNumber, trackingCompany, authToken) {
    let shopify_domain = "";
    let shopify_access_token = "";
  
    if (!authToken) {
      console.error("Authentication token is missing");
      return;
    }
  
    // Get Shopify domain and access token
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/get-shopify-auth-details`, {
        headers: { Authorization: `Bearer ${authToken}` }
      });
      shopify_domain = response.data.shopify_domain;
      shopify_access_token = response.data.shopify_access_token;
    } catch (error) {
      console.error("Error retrieving Shopify domain name or access token:", error);
    }
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/fetchShopifyOrders/fulfill-order`,  
        {
          shopifyDomain: shopify_domain, // Replace with the Shopify domain
          shopifyAccessToken: shopify_access_token, // Replace with the Shopify access token
          orderId,
          lineItemId,
          trackingNumber,
          trackingCompany
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`, // Passing the token in headers if needed
            'Content-Type': 'application/json'
          }
        }
      );
      // You can add logic here to update the UI or notify the user that the order is fulfilled.
    } catch (error) {
      console.error("Error fulfilling the order:", error);
      // You can display an error message to the user here.
    }
  };
  